<template>
  <section>
    <div class="container">
      <div class="images">
        <img src="~assets/images/smile5.jpg">
        <img src="~assets/images/backpack8.jpg">
        <img src="~assets/images/smiling12.jpg">
        <img src="~assets/images/backpack9.jpg">
      </div>
      <div class="content">
        <h2>More Stories</h2>
        <div v-for="story in stories">
          <h5 v-html="story.title"></h5>
          <div v-html="story.content"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'more-stories',
  props: ['stories']
}
</script>

<style lang="scss" scoped>
@import "~assets/styles/vars";

section {
  background-color: lighten($gold, 15%);
  .container {
    display: flex;
    .images {
      @include media('tablet-wide', 'max') {
        display: none;
      }
      margin-right: 5rem;
      img {
        margin-bottom: 0.75rem;
        max-width: 427px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .content {
      padding: 5rem 0 2rem;
      h5 {
        text-transform: uppercase;
        letter-spacing: 1px;
        margin: 3rem 0 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// MoreStories.vue?7c7438ec